module.exports = __webpack_public_path__ + "static/media/edit.1f00f7a1.svg";